// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DpsajBFUroAzNbaYQG2c {
  display: flex;
  position: relative;
  width: 100%;
  overflow: hidden;
}
[data-one-item='false'] .DpsajBFUroAzNbaYQG2c {
  margin-left: var(--campaign-grid-multiple-margin-left);
}
.n1a_3R61jw8Sz_jStCCy {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 8px;
  overflow-x: auto;
  overflow-y: hidden;
  scrollbar-width: none;
  -ms-overflow-style: none;
  padding-right: 8px;
}
@media (orientation: portrait) {
  .n1a_3R61jw8Sz_jStCCy {
    margin-bottom: 14px;
    padding: 0 8px;
  }
}
.n1a_3R61jw8Sz_jStCCy::-webkit-scrollbar {
  display: none;
}
.W1AglI22jRAeCoHg7a16 {
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/features/campaigns/components/defaults/MultiCampaignGrid/MultiCampaignGrid.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,sDAAsD;AACxD;AACA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,wBAAwB;EACxB,kBAAkB;AACpB;AACA;EACE;IACE,mBAAmB;IACnB,cAAc;EAChB;AACF;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;AACjB","sourcesContent":[".scrollableCampaignGridWrapper {\n  display: flex;\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n}\n[data-one-item='false'] .scrollableCampaignGridWrapper {\n  margin-left: var(--campaign-grid-multiple-margin-left);\n}\n.multiCampaignGridContainer {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  overflow-x: auto;\n  overflow-y: hidden;\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n  padding-right: 8px;\n}\n@media (orientation: portrait) {\n  .multiCampaignGridContainer {\n    margin-bottom: 14px;\n    padding: 0 8px;\n  }\n}\n.multiCampaignGridContainer::-webkit-scrollbar {\n  display: none;\n}\n.multiCampaignGridCardWrapper {\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"scrollableCampaignGridWrapper": `DpsajBFUroAzNbaYQG2c`,
	"multiCampaignGridContainer": `n1a_3R61jw8Sz_jStCCy`,
	"multiCampaignGridCardWrapper": `W1AglI22jRAeCoHg7a16`
};
export default ___CSS_LOADER_EXPORT___;
